module.exports = __webpack_public_path__ + "img/dweb.728097b5.svg";